import { useState, useRef } from "react";

const FileDragAndDropTarget = ({ onFileSelected, className, children }) => {
  const [file, setFile] = useState(null);
  const [dragging, setDragging] = useState(false);
  const dragCounter = useRef(0);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setDragging(true);
    }
  };

  const handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current--;
    if (dragCounter.current === 0) {
      setDragging(false);
    }
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    dragCounter.current = 0;
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setFile(e.dataTransfer.files[0]);
      onFileSelected(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };
  return (
    <div
      onDragEnter={handleDragIn}
      onDragLeave={handleDragOut}
      onDragOver={handleDrag}
      onDrop={handleDrop}
      className={`${className} ${
        dragging ? "!border-dashed !border-[#f27a35a6] !border-3" : ""
      }`}
    >
      {children}
    </div>
  );
};

export default FileDragAndDropTarget;
